import { Component, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { CityService } from './city.service';
import { ExceldownloadComponent } from 'src/app/views/directives/exceldownload/exceldownload.component';
import { BaseClass } from 'src/app/views/utility/baseClass';
import { GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { CitymodalComponent } from '../../directives/citymodal/citymodal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';

@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.css']
})
export class CityComponent extends BaseClass implements OnInit {
 @ViewChild('dt') dt: any;
  public tableData: any[] = [];
  excel_paragraph = '';
  public selectedItem: MenuItem | null = null;
  public commonScrollHeight = '';
  public searchText: string;
  public ref: DynamicDialogRef | undefined;
  public first2: number = 0;
  public rows2: number = 10;
  public totalRecords: number = 0;
  exceldownloadModal = false;
  public options = [];
  public paginatorArray = [];
  public visible: boolean = false;
  public position = 'top';
  public cols = [];
  public _selectedColumns = [];
  currentPageIndex: number = 0;
  rowsize: number = 10;
  tablecount: number = 0;
  message: GlobalMessage = new GlobalMessage();
  searchTerm: string = ''; 

  constructor(
    public router: Router,
    public dialogService: DialogService,
    public utilityservice: Utilityservice,
    private cityService: CityService,
    private spinnerservice: NgxSpinnerService,
    public override injector: Injector, // Make injector public here
    public PagehelpmodalService: PagehelpmodalService
  ) {
    super(injector);
    this.excel_paragraph = this.message.downloadexcel_text;
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
    this.getList();
    this.dynamiccols();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }

  dynamiccols() {
    this.cols = [
      { field: 'cityid', header: 'City ID', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: 'cityname', header: 'City', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'otherheader' },
      { field: 'createdby', header: 'Created By', type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },  
      { field: 'createdon', header: 'Created On', type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: 'activeflag', header: 'Status', type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' }
    ];
    this._selectedColumns = this.cols;
  }
 

  getList() {

    this.spinnerservice.show();
    const currentPageSize = this.rowsize;
    this.cityService.getCityData().subscribe({
      next: (data: any) => {
        this.spinnerservice.hide();
        this.tableData = data;
        this.tableData = data.map(item => ({ ...item, isSelect: false }));
        this.options = this.utilityservice.getOptionDropdown(data.length);
        this.paginatorArray = this.options.map(e => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = this.tableData.length;
        this.tablecount = data.count ?? data.length;
        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      },

      error: (error) => {
        this.spinnerservice.hide();
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error!",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      }
    });
  }



  showDialog() {
    let payload = {}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname: "City_Master_Data.xlsx", downloadapi: 'common/gen/citydataexcel', method: 'get', message: this.excel_paragraph, payload: payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
    });
  }

  closedpop() {
    this.visible = false;
  }

  show(title, data) {
    let details = {};
    if (title === 'Modify City') {
      this.spinnerservice.hide();
      this.cityService.getCityById(data.cityid, Number).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(CitymodalComponent, {
          header: title,
          width: '50vw',
          height: 'auto',
          data: { title: title, datas: details },
          contentStyle: {},


        });
        this.ref.onClose.subscribe(() => {
          this.getList();
        });
      });
    } else {
      details = {};
      this.ref = this.dialogService.open(CitymodalComponent, {
        header: title,
        width: '50vw',
        height: 'auto',
        data: { title: title, datas: details },
        contentStyle: { overflow: '' },

      });
      this.ref.onClose.subscribe(() => {
        this.getList();
      });
    }
  }

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }
  //Download Department Master Excel
  downloadgridexcel() {
    this.cityService.cityDataExcel().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'City_Master_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }
  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      // Handle null values
      if (value1 == null && value2 != null) return -1;
      if (value1 != null && value2 == null) return 1;
      if (value1 == null && value2 == null) return 0;

      // Check if the field is createdon for date comparison
      if (event.field === 'createdon') {
        // Parse the date strings to Date objects
        const date1 = new Date(value1);
        const date2 = new Date(value2);
        return date1.getTime() - date2.getTime(); // Sort by timestamp
      }

      // Handle string comparisons for other fields
      if (typeof value1 === 'string' && typeof value2 === 'string') {
        return value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
      }

      // Fallback to default number comparison for other types (like CIN Number)
      return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
    });

    // Reverse the data array if the order is descending
    return event.order === -1 ? event.data.reverse() : event.data;
  }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }


}
